module.exports = __webpack_public_path__ + "img/Weapon_61.cda1899b.png";